import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RatingModal({ open, onOpenChange, ride, target, onRated }) {
  const [stars, setStars] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!ride) return;
    setLoading(true);
    try {
      await axios.post(`${API}/rides/${ride.ride_id}/rate`, { stars, comment });
      toast.success("Avaliação enviada!");
      onRated?.();
      onOpenChange(false);
      setComment("");
      setStars(5);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro");
    } finally { setLoading(false); }
  };

  if (!ride) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Como foi sua corrida?</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-2">
          <Avatar className="w-20 h-20 ring-4 ring-primary/20">
            <AvatarImage src={target?.picture} />
            <AvatarFallback className="text-2xl">{target?.name?.[0]}</AvatarFallback>
          </Avatar>
          <div className="text-center">
            <div className="font-bold text-lg">{target?.name}</div>
            <div className="text-xs text-muted-foreground">{target?.role || ""}</div>
          </div>

          <div className="flex gap-1" onMouseLeave={() => setHover(0)}>
            {[1, 2, 3, 4, 5].map((n) => {
              const active = (hover || stars) >= n;
              return (
                <button
                  key={n}
                  data-testid={`star-${n}`}
                  onMouseEnter={() => setHover(n)}
                  onClick={() => setStars(n)}
                  className="transition-transform hover:scale-110"
                >
                  <Star
                    className={`w-10 h-10 ${active ? "text-yellow-400 fill-yellow-400" : "text-muted-foreground/30"}`}
                  />
                </button>
              );
            })}
          </div>

          <Textarea
            data-testid="rating-comment"
            placeholder="Deixe um comentário (opcional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            className="w-full"
          />

          <div className="flex gap-2 w-full">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 rounded-full">
              Depois
            </Button>
            <Button data-testid="rating-submit" onClick={submit} disabled={loading} className="flex-1 rounded-full">
              {loading ? "Enviando..." : "Enviar"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
